import styled from 'styled-components'

import _AffirmLogo from '~/components/affirm-logo'
import Button from '~/components/button'
import _CheckoutStep from '~/components/checkout-step/checkout-step.component'
import ContentBlock from '~/components/content-block'
import {
  SubStepAction,
  SubStepContent,
  SubStepHeading,
} from '~/components/substep'
import { font, device } from '~/styles/utils'

export const PageTitle = styled.h1`
  font-size: 28px;
  ${font('bold')};
  margin: 32px 0 0;

  @media ${device('notMobile')} {
    margin: 96px 0 48px;
    font-size: 32px;
  }
`

export const StepTitle = styled.h1`
  font-size: 28px;
  margin-top: 32px;
  color: ${({ theme }) => theme.color.text.default};

  @media ${device('notMobile')} {
    margin-top: 0;
  }
`

export const SubTitle = styled(ContentBlock)`
  & p {
    margin: 0;
    color: ${({ theme }) => theme.color.text.default};
  }
`

export const StepsWrapper = styled.div`
  margin-bottom: 100px;

  && h2.substep-title {
    margin: 1px;
  }

  .amp-form-field.disabled {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;
  }
`

export const CheckoutStep = styled(_CheckoutStep)`
  border-bottom: 1px solid ${({ theme }) => theme.color.border.default};

  && {
    padding: 40px 0;
  }

  ${SubStepHeading} {
    grid-column: 2;
  }

  ${SubStepAction} {
    grid-column: 3;
  }

  ${SubStepContent} {
    grid-column-end: -1;
    text-align: left;
  }
`

export const CheckoutStepTitle = styled.span`
  margin-right: 15px;
`

export const ChangeButton = styled(Button)`
  &&& {
    margin-left: 0;
  }
`

export const Header = styled.div`
  margin-bottom: 54px;
`

export const AffirmContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media ${device('notMobile')} {
    flex-direction: row;
    align-items: center;
  }
`

export const AffirmLogo = styled(_AffirmLogo)`
  width: 80px;
  @media ${device('notMobile')} {
    width: 100px;
  }
`

export const AffirmFootnote = styled(ContentBlock).attrs(() => ({
  buttonType: 'inline',
}))`
  &&& a {
    font-size: 14px;
    @media ${device('notMobile')} {
      font-size: 16px;
    }
  }

  &&& p {
    font-size: 14px;
    @media ${device('notMobile')} {
      font-size: 16px;
    }
  }
`

export const AffirmSubheading = styled.h2`
  font-size: 18px;
  line-height: 1;
`

export const NoPaymentRequiredMessage = styled.span`
  size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.color.text.default};
`
